import { uploadUri } from '../appConfig';

/**
 * return a `.video-block`
 *
 * must exists a template under `._template-block`
 */
const generateVideoBlock = (data) => {
	const template = document.querySelector('._template-block > .video-block').cloneNode(true);

	template.firstChild.setAttribute(
		'style',
		`background-image: url(${uploadUri}/${data.thumb})`,
	);
	template.lastChild.lastChild.innerText = data.title;

	template.lastChild.addEventListener('click', () => {
		document.querySelector('.youtube-video').innerHTML = `<iframe frameborder="0"
		allowfullscreen="1" 
		width="100%" 
		height="100%" 
		src="https://www.youtube.com/embed/${data.youtube_id}?enablejsapi=1&amp;controls=1&amp;autohide=1&amp;
		autoplay=1&amp;showinfo=1&amp;rel=0&amp;theme=dark&amp;wmode=opaque"></iframe>`;
	});

	return template;
};

export default generateVideoBlock;



// WEBPACK FOOTER //
// ./src/js/about/generateVideoBlock.js